import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import publicIp from "public-ip";

import { setLocalAuditLogData, setLocalIpAddress } from "../../redux/actions/accounts.action";
import { useAuditLog } from "./useAuditLog";
import { aesEncryption } from "../../networking/security";

const useIp = () => {
    const dispatch = useDispatch();
    const { pathname } = useLocation();
    const auditLogData = useAuditLog();

    const configuration = useSelector((state) => state.accountState.localIpAddress);
    const stateUsername = useSelector(
        (state) => state.accountState?.singleSmeAccount?.signatory?.email,
    );
    const localUsername = sessionStorage.getItem("kudaUserEmail");

    const getClientIP = useCallback(async () => {
        try {
            const result = await publicIp.v4();

            dispatch(setLocalIpAddress("ip", result));
        } catch {}
    }, [dispatch]);

    useEffect(() => {
        if (!configuration?.ip) getClientIP();

        if ("geolocation" in navigator) {
            navigator.geolocation.watchPosition(function (position) {
                const geolocation = `${position.coords.longitude}, ${position.coords.latitude}`;
                dispatch(setLocalIpAddress("geolocation", geolocation));
                sessionStorage.setItem("location", geolocation);
            });
        }
        // eslint-disable-next-line
    }, [configuration?.ip]);

    useEffect(() => {
        if (configuration?.ip) {
            localStorage.setItem(
                "kudaAuditLog",
                aesEncryption(
                    `${JSON.stringify(auditLogData)}`,
                    `${process.env.REACT_APP_ENCRYPTION_KEY}`,
                ),
            );
            dispatch(setLocalAuditLogData(auditLogData));
        }
        // eslint-disable-next-line
    }, [pathname, configuration?.ip, localUsername, stateUsername]);

    return null;
};

export default useIp;
